export enum MissionTimeTypeEnum {
  ANY_TIME = 'any_time',
  PERIOD = 'period',
  SPECIFIC_DATE = 'specific_date',
}
